import { __rest, __assign } from '../../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';
import React from 'react';
import ConfigContext from '../context/index.js';

var TiConfigProvider = function TiConfigProvider(props) {
  var children = props.children,
    restProps = __rest(props, ["children"]);
  return /*#__PURE__*/React.createElement(ConfigContext.Provider, {
    value: __assign({}, restProps)
  }, children);
};

export { TiConfigProvider as default };
